import styled from "styled-components";
import { theme } from "../../theme";

export const StyledDirectionForm = styled.div`
	& textarea {
		font-size: 1.2rem;
		font-weight: 400;
	}

	& .default-fields {
		display: flex;
		align-items: flex-start;
		column-gap: 1rem;

		& > *:first-child {
			width: 12rem;
		}

		& > *:nth-child(2) {
			width: 100%;
		}
	}

	& .type-fields {
		display: flex;
		align-items: center;
		column-gap: 1rem;

		& > *:first-child {
			width: 22rem;
			max-width: 16.1rem;
		}

		& > *:nth-child(2) {
			width: 100%;
			height: 4.5rem;
			padding-bottom: 0.8rem;
		}
	}

	& .url-fields {
		margin-top: 0.5rem;
	}

	& .responsible-fields {
		margin-top: 2rem;

		& > div:not(:first-child) {
			max-height: 30rem;
			overflow-y: scroll;
		}

		& > *:first-child {
			width: 100%;

			margin-bottom: 2rem;

			& input {
				max-width: none;
			}
		}

		& label {
			margin-top: 0.75rem;

			display: flex;
			align-items: center;
			column-gap: 1.25rem;

			font-size: 1.2rem;
			font-weight: 300;
			text-transform: capitalize;

			cursor: pointer;
		}
	}

	& .decision-fields {
		margin-top: 2rem;

		& > div:not(:first-child) {
			max-height: 30rem;
			overflow-y: scroll;
		}

		& > label:first-child {
			font-size: 0.8rem;
			font-weight: 500;
			font-family: museo-sans, sans-serif;
			color: #4d5660;
			margin-bottom: 0.1rem;
			text-transform: uppercase;
		}

		& > form {
			margin-top: 2rem;
		}

		& > div:first-of-type {
			width: 100%;

			margin-bottom: 2rem;

			& input {
				max-width: none;
			}
		}

		& label {
			margin-top: 0.75rem;

			display: flex;
			align-items: center;
			column-gap: 1.25rem;

			font-size: 1.2rem;
			font-weight: 300;
			text-transform: capitalize;

			cursor: pointer;
		}
	}
`;

export const StyledSelectableDirectionType = styled.form`
	display: flex;
	align-items: flex-end;
	column-gap: 1rem;

	& label {
		padding-left: 3.5rem;
		position: relative;

		display: flex;

		font-size: 1.2rem;
		font-weight: 300;
		text-transform: capitalize;
	}

	& .checkmark {
		position: absolute;
		top: 50%;
		left: 1rem;
		width: 1.8rem;
		height: 1.8rem;
		border-radius: 50%;
		border: 0.1rem solid ${theme.color.gray0};
		background-color: transparent;
		transform: translateY(-50%);

		&:after {
			content: "";
			position: absolute;
			display: none;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: ${theme.color.green};
		}
	}

	& input {
		position: absolute;
		opacity: 0;
		cursor: pointer;

		&:checked {
			& ~ .checkmark {
				background-color: ${theme.color.white};

				&:after {
					display: block;
				}
			}
		}
	}
`;
